<style lang="scss" scoped>
    .species-layout {
        padding: 25px;
        display: flex;
        flex-direction: column;

        @include above(md) {
            padding: 50px 125px;
        }

        &__content {
            flex: 1 0 auto;
            display: flex;
            flex-wrap: wrap;

            @include above(md) {
                flex-wrap: nowrap;
            }
        }

        &__progress {
            flex: 0 0 auto;
            margin-right: 50px;
            display: none;
            z-index: z(above);

            @include above(md) {
                display: block;
            }
        }

        &__page-content {
            flex: 1 1 auto;
        }
    }
</style>
<template>
    <main class="species-layout">
        <!-- <neon-title v-if="progressData.length && neonTitle" :color="progressData[this.progress ].color" :title="neonTitle" /> -->
        <div class="species-layout__content">
            <div class="species-layout__progress">
                <progress-bar :links="progressLinks" :title-overrides="progressTitles" :current-progress="progress" :progress-data="progressData" />
            </div>
            <transition :name="routeTransition" mode="out-in">
                <router-view class="species-layout__page-content"></router-view>
            </transition>
        </div>
    </main>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import NeonTitle from '@/components/NeonTitle'
import ProgressBar from '@/components/ProgressBar'

export default {
    name: 'SpeciesLayout',
    data: () => ({
        routeTransition: 'slide-up',
    }),
    computed: {
        ...mapState([
            'neonTitle',
            'progressData',
            'progress',
            'progressLinks',
            'progressTitles',
        ]),
    },
    watch: {
        '$route'(to, from) {
            const toDepth = to.path.split('/').filter(segment => Boolean(segment)).length
            const fromDepth = from.path.split('/').filter(segment => Boolean(segment)).length
            this.routeTransition = toDepth < fromDepth ? 'slide-down' : 'slide-up'
        },
    },
    methods: {
        ...mapActions([
            'getSpecies',
            'getProgressData',
        ]),
    },
    mounted() {
        this.getSpecies()
        this.getProgressData()
    },
    components: {
        NeonTitle,
        ProgressBar,
    },
}
</script>
